module.exports = __webpack_public_path__ + "static/media/customer-4.a5c31b41.jpg";